(function() { window.GUID_75bcf815_bf97_4096_9be3_50bbd8a8d42a = { getGuid: function() { return "75bcf815-bf97-4096-9be3-50bbd8a8d42a"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ComparedValueBarChart {
            constructor(params) {
                this.id = CS.Helper.generateRandomId();
                this.appElement = null;
                this.containerElement = null;
                this.innerChartElement = null;
                this.innerChartContainerElement = null;
                this.state = CS.Enumeration.ChartState.Unready;
                this.datapoints = [];
                this.svg = null;
                this.chartWidth = 1200;
                this.chartHeight = 0;
                this._barHeight = 40;
                this.barHeight = this._barHeight;
                this.marginTop = 1;
                this.marginRight = 2;
                this.marginBottom = 1;
                this.marginLeft = 2;
                this.numBars = 0;
                this.fontFamily = `"Open Sans", sans-serif`;
                this.shouldStack = false;
                this.colors = [];
                this.seriesIds = [];
                if (params.id)
                    this.id = params.id;
                this.datapoints = params.datapoints;
                this.shouldStack = this.datapoints.some((d) => d.isStacked);
                this.baseContainerElementId = params.containerElementId;
                this.colors = params.colors;
                this.setChartDimensions();
            }
            setFallbackHrefs() {
                try {
                    if (!this.appElement) {
                        return;
                    }
                    const $images = $(this.appElement).find(".datapoint-avatar img");
                    if (!$images.length) {
                        return;
                    }
                    $images.each((_, element) => {
                        const $element = $(element);
                        const href = $element.attr("href");
                        const fallbackHref = $element.attr("data-fallback-href");
                        const image = new Image();
                        image.onerror = () => {
                            $element.attr("href", fallbackHref);
                        };
                        if (!CS.Helper.isNullOrWhiteSpace(href)) {
                            image.src = href;
                        }
                    });
                }
                catch (error) {
                    console.error("Error while handling window loaded.", error);
                }
            }
            setChartDimensions() {
                var _a;
                if ((_a = this.series) === null || _a === void 0 ? void 0 : _a.length) {
                    this.chartHeight =
                        this.series[0].length * this.barHeight +
                            this.marginTop +
                            this.marginBottom;
                }
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                });
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.setState(CS.Enumeration.ChartState.Initializing);
                        this.createHTML();
                        yield this.load();
                        this.render()
                            .then(() => {
                            this.setState(CS.Enumeration.ChartState.Ready);
                            this.setFallbackHrefs();
                        })
                            .catch((error) => {
                            console.error(error);
                            this.setState(CS.Enumeration.ChartState.Error);
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                    }
                });
            }
            createHTML() {
                this.appElement = document.body.querySelector(`#${this.baseContainerElementId}`);
                if (this.appElement == null) {
                    throw new Error("Container element not found.");
                }
                const containerHtml = `<div id="compared-value-bar-chart-${this.id}" class="compared-value-bar-chart chart"></div>`;
                const containerElementExists = document.body.querySelector(`#compared-value-bar-chart-${this.id}`) !=
                    null;
                if (!containerElementExists) {
                    this.appElement.insertAdjacentHTML("beforeend", containerHtml);
                    this.containerElement = document.body.querySelector(`#compared-value-bar-chart-${this.id}`);
                }
                if (this.containerElement == null) {
                    throw new Error("Container element not found.");
                }
                const innerChartContainerHtml = `<div class="compared-value-bar-chart__chart-container chart-container" style="position: relative;"></div>`;
                const innerChartContainerElementExists = document.body.querySelector(`#compared-value-bar-chart-${this.id} .compared-value-bar-chart__chart-container`) != null;
                if (!innerChartContainerElementExists) {
                    this.containerElement.insertAdjacentHTML("beforeend", innerChartContainerHtml);
                    this.innerChartContainerElement = document.body.querySelector(`#compared-value-bar-chart-${this.id} .compared-value-bar-chart__chart-container`);
                }
                if (this.innerChartContainerElement == null) {
                    throw new Error("Inner chart container element not found.");
                }
                const innerChartHtml = `<div class="compared-value-bar-chart__chart" style="position: relative;"></div>`;
                const innerChartElementExists = document.body.querySelector(`#compared-value-bar-chart-${this.id} .compared-value-bar-chart__chart`) != null;
                if (!innerChartElementExists) {
                    this.innerChartContainerElement.insertAdjacentHTML("beforeend", innerChartHtml);
                    this.innerChartElement = document.body.querySelector(`#compared-value-bar-chart-${this.id} .compared-value-bar-chart__chart`);
                }
                if (this.innerChartElement == null) {
                    throw new Error("Inner chart element not found.");
                }
            }
            load() {
                return __awaiter(this, void 0, void 0, function* () {
                    // Determine the series that need to be stacked.
                    this.series = d3
                        .stack()
                        .keys(d3.union(this.datapoints.map((d) => d.seriesId))) // distinct series keys, in input order
                        .value(([, D], key) => D.get(key).value) // get value for each series key and stack
                        .offset(d3.stackOffsetExpand)(d3.index(this.datapoints, (d) => d.stackId, (d) => d.seriesId)); // group by stack then series key
                    this.seriesIds = this.series.map((d) => d.key);
                    this.numBars = this.datapoints.length;
                    if (this.shouldStack) {
                        this.numBars = this.datapoints.filter((d) => !d.isStacked).length;
                    }
                    this.setChartDimensions();
                });
            }
            render() {
                return new Promise((resolve, reject) => {
                    try {
                        // Prepare the scales for positional and color encodings.
                        this.xScale = d3
                            .scaleLinear()
                            .domain([
                            0,
                            d3.max(this.series, (d) => d3.max(d, (d) => d[1])),
                        ])
                            .range([this.marginLeft, this.chartWidth - this.marginRight]);
                        this.yScale = d3
                            .scaleBand()
                            .domain(d3.groupSort(this.datapoints, (D) => -D.find((d) => d.seriesId === this.seriesIds[0]).value /
                            d3.sum(D, (d) => d.value), (d) => d.stackId))
                            .range([this.marginTop, this.chartHeight - this.marginBottom])
                            .padding(0.08);
                        // Create the SVG container.
                        this.svg = d3
                            .create("svg")
                            .attr("width", this.chartWidth)
                            .attr("height", this.chartHeight)
                            .attr("viewBox", [0, 0, this.chartWidth, this.chartHeight])
                            .attr("style", "max-width: 100%; height: auto;");
                        // Append a group for each series, and a rect for each element in the series.
                        this.svg
                            .append("g")
                            .selectAll()
                            .data(this.series)
                            .join("g")
                            .attr("fill", (d) => {
                            return this.colors[d.index];
                        })
                            .selectAll("rect")
                            .data((D) => D.map((d) => ((d.key = D.key), d)))
                            .join("rect")
                            .attr("x", (d) => this.xScale(d[0]))
                            .attr("y", (d) => this.yScale(d.data[0]))
                            .attr("height", this.yScale.bandwidth())
                            .attr("width", (d) => this.xScale(d[1]) - this.xScale(d[0]));
                        // .append("title")
                        // .text(
                        //   (d) =>
                        //     `${d.data[0]} ${d.key}\n${formatValue(
                        //       d.data[1].get(d.key).population
                        //     )}`
                        // );
                        // Append the horizontal axis.
                        this.svg
                            .append("g")
                            .attr("transform", `translate(0,${this.marginTop})`)
                            .call(d3.axisTop(this.xScale).ticks(3))
                            .call((g) => g.selectAll(".domain").remove())
                            .call((g) => g.selectAll(".tick text").remove())
                            .call((g) => g
                            .selectAll(".tick line")
                            .attr("y2", this.chartHeight)
                            .attr("stroke", "white")
                            .attr("stroke-width", 2));
                        // Append the vertical axis.
                        //svg
                        //  .append("g")
                        //  .attr("transform", `translate(${marginLeft},0)`)
                        //  .call(d3.axisLeft(y).tickSizeOuter(0))
                        //  .call((g) => g.selectAll(".domain").remove());
                        const svgNode = this.svg.node();
                        if (!svgNode) {
                            return reject(new Error("SVG node not found."));
                        }
                        if (!this.innerChartElement) {
                            return reject(new Error("Chart element not found."));
                        }
                        if (!this.innerChartContainerElement) {
                            return reject(new Error("Chart container element not found."));
                        }
                        this.innerChartElement.appendChild(svgNode);
                    }
                    catch (error) {
                        return reject(error);
                    }
                });
            }
            setState(newState) {
                this.state = newState;
                this.updateUI();
            }
            updateUI() {
                switch (this.state) {
                    case CS.Enumeration.ChartState.Initializing:
                    case CS.Enumeration.ChartState.Unready:
                    case CS.Enumeration.ChartState.Ready:
                    case CS.Enumeration.ChartState.Destroying:
                    case CS.Enumeration.ChartState.Running:
                    case CS.Enumeration.ChartState.Stopping:
                    case CS.Enumeration.ChartState.Stopped:
                    case CS.Enumeration.ChartState.Error:
                    case CS.Enumeration.ChartState.Finished:
                    default:
                        break;
                }
            }
            destroy() {
                return new Promise((resolve, reject) => {
                    try {
                        this.setState(CS.Enumeration.ChartState.Destroying);
                        this.svg.remove();
                    }
                    catch (error) {
                        console.error(error);
                        this.setState(CS.Enumeration.ChartState.Error);
                        reject(error);
                    }
                });
            }
        }
        Controls.ComparedValueBarChart = ComparedValueBarChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ComparedValueBarChart.js.map
